import { defineStore } from "pinia";
interface api {
    totalSerp: number;
    leftSerp: number;
    totalX: number;
    leftX: number;
}
const userStore = defineStore("user", {
    state: () => {
        return {
            token: "" as string | null,
            userInfo: {} as any | null,
            apiCnt: {} as api | null,
            perPage: 100 as number | null,
            listLayer: 0 as number | null,
        };
    },
    actions: {
        setToken(token: string | null) {
            this.token = token;
        },
        setApiCnt(cnt: api | null) {
            this.apiCnt = cnt;
        },
        setInfo(userInfo: object | null) {
            this.userInfo = userInfo;
        },
        setPerPage(size: number | null) {
            this.perPage = size;
        },
        setListLayer(idx: number | null) {
            this.listLayer = idx;
        },
    },
});

export default userStore;
